<template>
  <v-app>

    <Alert /> 
    
    <div class="app"> 

      <SideMenu /> 

      <Header />
     
      <v-main class="content">        
        <div class="cardContent">
            <v-container>

                <v-row>
                    <v-col cols="12" md="12">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Pesquisar Hidrantes"
                            single-line
                            hide-details
                            solo
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="12">
                        <v-btn 
                            small 
                            color="#ea6936" 
                            dark
                            @click="redirectPage('/hidrante/novo')"
                        >
                            Criar Hidrante
                        </v-btn>
                    </v-col>
                </v-row>                
                
                <v-row>
                    <v-col cols="12" md="12">
                        <v-data-table
                            :headers="headers"
                            :items="base"
                            :search="search"
                            sort-by="id"
                            class="elevation-1"
                        >
                            <template v-slot:[`item.local`]="{ item }">
                                {{ showNameLocal(item.local) }}                                
                            </template> 
                            <template v-slot:[`item.mangueira`]="{ item }">
                                {{ showNameMangueira(item.mangueira) }}                                
                            </template> 
                            <template v-slot:[`item.ativo`]="{ item }">
                                <div v-if="item.ativo === true">
                                    Ativo
                                </div>
                                <div v-else>
                                    Inativo
                                </div>
                            </template>  
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-btn
                                    x-small                                            
                                    color="#ea6936" 
                                    dark 
                                    @click="redirectPage('/hidrante/editar/', item._id)"
                                >
                                    Editar
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

            </v-container>        
        </div>
      </v-main>
    
    </div>   
  
  </v-app>
</template>

<script>
    import Alert from '@/_components/shared/Alert';
    import Header from '@/_components/Header';
    import SideMenu from '@/_components/SideMenu';
    import http from '@/_services/http';
    import store from "@/_store";

    export default {
        components: {
            Alert,
            Header,
            SideMenu
        },

        data: () => ({
            search: '',
            headers: [
                {
                    text: 'Número de Patrimônio',
                    align: 'start',
                    value: 'numero_patrimonio', 
                    sortable: true,                     
                    filterable: true          
                },
                {
                    text: 'Mangueira',
                    align: 'start',
                    value: 'mangueira', 
                    sortable: true,                     
                    filterable: true          
                },
                { 
                    text: 'Local',
                    align: 'center',
                    value: 'local', 
                    sortable: true,                     
                    filterable: true   
                },
                { 
                    text: 'Status', 
                    align: 'center',
                    value: 'Status', 
                    sortable: true,                     
                    filterable: true   
                },
                { 
                    text: 'Situação', 
                    align: 'center',
                    value: 'ativo', 
                    sortable: true,                     
                    filterable: true   
                },
                { 
                    text: '', 
                    value: 'actions',
                    sortable: false, 
                    filterable: false 
                },
            ],
            base: [],
            listaMangueiras: [
                    {
                        "id": 1,
                        "value": "Tipo 1 - 1 ½ 15 mts"
                    }, {
                        "id": 2,
                        "value": "Tipo 1 - 1 ½ 20 mts"
                    }, {
                        "id": 3,
                        "value": "Tipo 1 - 1 ½ 25 mts"
                    }, {
                        "id": 4,
                        "value": "Tipo 1 - 1 ½ 30 mts"
                    }, {
                        "id": 5,
                        "value": "Tipo 2 - 1 ½ 15 mts"
                    }, {
                        "id": 6,
                        "value": "Tipo 2 - 1 ½ 20 mts"
                    }, {
                        "id": 7,
                        "value": "Tipo 2 - 1 ½ 25 mts"
                    }, {
                        "id": 8,
                        "value": "Tipo 2 - 1 ½ 30 mts"
                    }, {
                        "id": 9,
                        "value": "Tipo 2 - 2 ½ 15 mts"
                    }, {
                        "id": 10,
                        "value": "Tipo 2 - 2 ½ 20 mts"
                    }, {
                        "id": 11,
                        "value": "Tipo 2 - 2 ½ 25 mts"
                    }, {
                        "id": 12,
                        "value": "Tipo 2 - 2 ½ 30 mts"
                    }, {
                        "id": 13,
                        "value": "Tipo 3 - 2 ½ 15 mts"
                    }, {
                        "id": 14,
                        "value": "Tipo 3 - 2 ½ 20 mts"
                    }, {
                        "id": 15,
                        "value": "Tipo 3 - 2 ½ 25 mts"
                    }, {
                        "id": 16,
                        "value": "Tipo 3 - 2 ½ 30 mts"
                    }, {
                        "id": 17,
                        "value": "Tipo 4 - 2 ½ 15 mts"
                    }, {
                        "id": 18,
                        "value": "Tipo 4 - 2 ½ 20 mts"
                    }, {
                        "id": 19,
                        "value": "Tipo 4 - 2 ½ 25 mts"
                    }, {
                        "id": 20,
                        "value": "Tipo 4 - 2 ½ 30 mts"
                    }, {
                        "id": 21,
                        "value": "Tipo 5 - 2 ½ 15 mts"
                    }, {
                        "id": 22,
                        "value": "Tipo 5 - 2 ½ 20 mts"
                    }, {
                        "id": 23,
                        "value": "Tipo 5 - 2 ½ 25 mts"
                    }, {
                        "id": 24,
                        "value": "Tipo 5 - 2 ½ 30 mts"
                    }
            ],
            listaLocais: []
        }),

        created () {
            this.initialize();
        },

        methods: {
            initialize () {
                http.get("hydrants/getAll")
                    .then((response) => {
                        this.base = response.data.Response;
                        this.buscarLocais();
                     })
                    .catch((error) => {
                        console.log(error);
                        store.dispatch("Notification/alert", {
                            type: "error",
                            message: "Ocorreu um erro",
                            timeClose: 3000
                        });
                    });
            },

            buscarLocais(){
                http.get("locals/getAll")
                    .then((response) => {
                        this.listaLocais = response.data.Response;
                     })
                    .catch((error) => {
                        console.log(error);
                        store.dispatch("Notification/alert", {
                            type: "error",
                            message: "Ocorreu um erro",
                            timeClose: 3000
                        });
                    });
            },

            showNameLocal(idLocal){
                let localName = this.listaLocais.filter(function (value){
                    return value._id == idLocal._id;
                }).map(value2 => { 
                    return value2.nome; 
                });
                return localName[0];
            },
            
            showNameMangueira(idMangueira){
                console.log(idMangueira);
                let mangueira = this.listaMangueiras.filter(function (value){
                    return value.id == idMangueira;
                }).map(value2 => { 
                    return value2.value; 
                });
                return mangueira[0];
            },

            redirectPage (url, id){
                let link = url + (id || "");
                window.location.href = link;
            },
        },
    }
</script>

<style scoped lang="scss">  
    .cardContent {
        display: flex;
        justify-content: center;
    }
    .cardContent .container {
        padding: 0;
    }
    .cardTabPerfil {
        padding: 20px;
    }
    .v-tab.v-tab {
        font-weight: bold;
    }
    .v-window.v-item-group.theme--light.v-tabs-items {
        padding: 40px 5px 0px 5px;
    }
    .rowButton {
        text-align: center;
    }
</style>